import { gql } from '@apollo/client';

export const COMMENT_FIELDS = gql`
  fragment commentInfo on CommentSchema {
    id
    createdAt
    updatedAt
    kind
    body
    html
    login {
      id
      firstname
      lastname
      initials
      profileImage {
        resolutions
      }
    }
  }
`;

export const ASSIGNMENTS_FIELDS = gql`
  fragment assignmentInfo on TaskAssignmentSchema {
    taskId
    loginId
    focusLevel
    login {
      fullname
    }
  }
`;

export const REMINDER_FIELDS = gql`
  fragment reminderInfo on ReminderDefinitionSchema {
    id
    spec
    reminder {
      id
      triggerAt
      payload
    }
  }
`;

export const TASK_FIELDS = gql`
  ${ASSIGNMENTS_FIELDS}
  ${REMINDER_FIELDS}
  fragment taskInfo on TaskSchema {
    id
    name
    details
    completed
    dueDate
    timeframe
    hasWedding
    weddingItem {
      clientVisible
    }
    hasLead
    hasComments
    lead {
      id
      contactFullName
      weddingDate
      organizationId
    }
    assignments {
      ...assignmentInfo
    }
    reminders {
      ...reminderInfo
    }
    currentLoginAssignment {
      loginOrder
      focusLoginOrder
    }
  }
`;
